// src/main.js
import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import components from '@/components/install'
import './assets/font/font.css'
import '@/styles/index.scss'
import pinia from './stores'  // 引入 Pinia 实例，已经注册了插件
import directives from '@/directive'
import MessageConfirm from '@/components/message-confirm/index.js'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import fr from 'element-plus/es/locale/lang/fr'
import com from '@/business-components/install'
import { maskPhone } from '@/utils/tools'
import i18n, { setLanguage } from './i18n'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './permission'
import App from './App.vue'

// 创建 i18n 实例，确保 i18n 初始化在 Vue 实例之前
const app = createApp(App)

import.meta.env.VITE_VUE_APP_SENTRY_DSN &&
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_VUE_APP_SENTRY_DSN,
  })

// Sentry 测试（可在浏览器控制台调用 window.testSentry()）
window.testSentry = () => {
  Sentry.captureMessage('Sentry 测试消息 - Test Message')
  Sentry.captureException(new Error('Sentry 测试异常 - Test Error'))
  console.log('Sentry test sent, check your Sentry dashboard.')
}

app.use(i18n)  // 在 Vue 实例创建前注册 i18n
setLanguage()  // 设置语言（如果有相关的语言存储或者设置）

// 注册 ElementPlus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

const currentLang = i18n.global.locale.value
let currentLocale = zhCn
if (currentLang == JSON.stringify("en")) currentLocale = en
else if (currentLang == JSON.stringify("fr")) currentLocale = fr
app.use(ElementPlus, {
  locale: currentLocale,
})

// 继续注册其他插件
app.use(com)
// 手机号脱敏展示（页面展示用；查询/复制/拨打/提交仍传完整号码）
app.config.globalProperties.$maskPhone = maskPhone
app.use(components)
app.use(pinia)  // 使用 Pinia
app.use(directives)
app.use(router)
app.use(MessageConfirm)

// 启动应用
app.mount('#app')
